module.exports = __webpack_public_path__ + "img/logo-hub-white.cf0e880d.png";